/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterSortALowToHighIcon24Solid = forwardRef('UiFilterSortALowToHighIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.5 3a1.5 1.5 0 1 0 0 3h4a1.5 1.5 0 1 0 0-3h-4Z" }),
        React.createElement("path", { d: "M2 11.5A1.5 1.5 0 0 1 3.5 10h10a1.5 1.5 0 0 1 0 3h-10A1.5 1.5 0 0 1 2 11.5Z" }),
        React.createElement("path", { d: "M2 18.5A1.5 1.5 0 0 1 3.5 17h17a1.5 1.5 0 0 1 0 3h-17A1.5 1.5 0 0 1 2 18.5Z" })));
});
